import { render, staticRenderFns } from "./ledgerList.vue?vue&type=template&id=0ede90c9&scoped=true&"
import script from "./ledgerList.vue?vue&type=script&lang=js&"
export * from "./ledgerList.vue?vue&type=script&lang=js&"
import style0 from "./ledgerList.vue?vue&type=style&index=0&id=0ede90c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede90c9",
  null
  
)

export default component.exports